exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".uu5-forms-item-list {\n  border: 1px solid #d9d9d9;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.15);\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.15);\n  position: absolute;\n  margin-top: 0.6em;\n  z-index: 10;\n  left: 1em;\n  right: 1em;\n  background-color: #fff;\n}\n.uu5-forms-item-list:before {\n  border: 0.5em solid transparent;\n  content: \"\";\n  height: 0;\n  width: 0;\n  position: absolute;\n  bottom: 100%;\n  right: 0.75em;\n  border-bottom-color: #fff;\n  z-index: 1001;\n}\n.uu5-forms-item-list:after {\n  border: 0.6em solid transparent;\n  content: \"\";\n  height: 0;\n  width: 0;\n  position: absolute;\n  bottom: 100%;\n  right: 0.625em;\n  border-bottom-color: #d9d9d9;\n}\n.uu5-forms-item-list-header {\n  border-bottom: 1px solid #d9d9d9;\n}\n.uu5-forms-item-list-body {\n  overflow-y: auto;\n  max-height: 10.8em;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./forms/internal/item-list.less
// module id = 321
// module chunks = 0